<!-- Nur das Zeichen traegt Farbe; der Text bleibt schwarz und linksbuendig. -->
<div class="message-box__icon" aria-hidden="true">!</div>
<div class="message-box__text">{{ message }}</div>
